import {StorageSourceCrud} from '../../api/org/storageSource/api';
import {PlusNoColorIcon} from '../../ui-components/Iconpack';
import {Button} from '../../ui-components/Button/button';
import React from 'react';
import {StorageSource, StorageType} from '../../api/types/organization/StorageSource';
import {toast} from 'react-toastify';

type LoadingState = 'init' | 'pending' | 'fulfilled' | 'rejected';

export default function NewFolder(props: {
    storageSourceCrud: StorageSourceCrud | undefined;
    onNewFolder: (src: StorageSource) => void;
}) {
    const [loading, setLoading] = React.useState<LoadingState>('init');

    const onNewFolder = (newFolderName: string) => {
        if (loading !== 'init') return;
        setLoading('pending');
        const currentId = toast(`Creating folder ${newFolderName}`, {
            type: 'info',
            autoClose: false,
            position: 'top-right',
        });
        props.storageSourceCrud
            ?.create({
                name: newFolderName,
                type: StorageType.DEFAULT_STORAGE,
                headers: [],
                origin: '',
                seo_enabled: true,
            })
            .then((response) => {
                toast.dismiss(currentId);
                toast(`Folder ${newFolderName} created`, {type: 'success', position: 'top-right', autoClose: 3000});
                setLoading('fulfilled');
                props.onNewFolder(response);
            })
            .catch((err) => {
                toast.dismiss(currentId);
                toast(`Failed to create folder ${newFolderName}: ${err}`, {type: 'error', autoClose: 3000});
                setLoading('rejected');
            })
            .then(() => {
                setLoading('init');
            });
    };

    const onClick = () => {
        const newFolderName = prompt('Enter new folder name');
        if (newFolderName) {
            onNewFolder(newFolderName);
        }
    };

    return (
        <Button disabled={loading !== 'init'} variant='outline' size={'sm'} icon onClick={onClick}>
            <PlusNoColorIcon />
            New Folder
        </Button>
    );
}
